const actions = {
	// Vertical NavMenu
	updateVerticalNavMenuWidth({commit}, width) {
		commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
	},

	// VxAutoSuggest
	updateStarredPage({commit}, payload) {
		commit('UPDATE_STARRED_PAGE', payload)
	},

	arrangeStarredPagesLimited({commit}, list) {
		commit('ARRANGE_STARRED_PAGES_LIMITED', list)
	},
	arrangeStarredPagesMore({commit}, list) {
		commit('ARRANGE_STARRED_PAGES_MORE', list)
	},

	toggleContentOverlay({commit}) {
		commit('TOGGLE_CONTENT_OVERLAY')
	},
	updateTheme({commit}, val) {
		commit('UPDATE_THEME', val)
	},

    
}

export default actions
